import { render } from "./ExpenseDetails.vue?vue&type=template&id=0c088399&scoped=true"
import script from "./ExpenseDetails.vue?vue&type=script&lang=js"
export * from "./ExpenseDetails.vue?vue&type=script&lang=js"

import "./ExpenseDetails.vue?vue&type=style&index=0&id=0c088399&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c088399"]])

export default __exports__